import { lazy } from "react";

// The one lazy boundary for react-fa-icon-picker — import IconPicker and
// IconPickerItem from here, never from the package.
//
// 2026-10-23: react-fa-icon-picker is 1.21 MB on its own (it re-exports the
// whole react-icons/fa set), which made it the single largest item in the
// first load — for an icon chooser on one question type's settings and an
// 18px icon next to a tiled list item.
//
// Both exports go through the same `load()` call, i.e. the same `import()`
// expression, on purpose: webpack creates one chunk per `import()` call site,
// so writing two separate `lazy(() => import("react-fa-icon-picker"))` lines
// would emit the 1.21 MB twice.
const load = () => import("react-fa-icon-picker");

export const IconPicker = lazy(() =>
  load().then((m) => ({ default: m.IconPicker }))
);

export const IconPickerItem = lazy(() =>
  load().then((m) => ({ default: m.IconPickerItem }))
);
